<template>
    <div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">첩약건보사전 신규 등록</h2>
        </section>
        <section class="view">
          <div class="table_list">
            <table class="write">
              <colgroup>
                <col width="200">
                <col width="*">
              </colgroup>
              <tbody>
                <tr>
                  <th><span class="emp">첩약건보사전명</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.insuranceDictionaryNm" placeholder="입력해주세요.">
                  </td>
                </tr>
                <tr>
                  <th><span>첩약건보사전한자명</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.insuranceDictionaryChinessNm" placeholder="입력해주세요.">
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">첩약건보사전출전</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.insuranceDictionarySource" placeholder="입력해주세요.">
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">첩약건보 질환구분</span></th>
                  <td>
                      <div class="form_select">
                        <b-form-select v-model="regData.nhisCategory" >
                          <b-form-select-option value="">선택</b-form-select-option>
                          <b-form-select-option v-for="(item, index) in NHIScategoryList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                        </b-form-select>
                      </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">첩약건보 처방유형</span></th>
                  <td>
                      <div class="form_select">
                        <b-form-select v-model="regData.nhisType" >
                          <b-form-select-option value="">선택</b-form-select-option>
                          <b-form-select-option v-for="(item, index) in NHISTypeList" :key="index" :value="item.dtl_code">{{item.dtl_code_nm}}</b-form-select-option>
                        </b-form-select>
                      </div>
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">기준처방코드</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.standardPrescibeCd" placeholder="입력해주세요.">
                  </td>
                </tr>
                <tr>
                  <th><span class="emp">첩상한금액</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.limitPrice" placeholder="입력해주세요.">
                  </td>
                </tr>                 
                <tr>
                  <th><span class="emp">사용여부</span></th>
                  <td>
                    <div class="form_inline">
                      <div class="form_radio">
                        <input type="radio"  value="Y" checked v-model="regData.useYn">
                        <label for="radio1">Y</label>
                      </div>
                      <div class="form_radio">
                        <input type="radio"  value="N" v-model="regData.useYn">
                        <label for="radio2">N</label>
                      </div>
                    </div>                   
                  </td>
                </tr>        
                <tr>
                  <th><span>처방 설명</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.insuranceDictionaryNote1" placeholder="입력해주세요.">
                  </td>
                </tr>                           
                <tr>
                  <th><span>참고사항</span></th>
                  <td>
                    <input type="text" class="form_control" v-model="regData.insuranceDictionaryNote2" placeholder="입력해주세요.">
                  </td>
                </tr>                           
                <tr>
                  <th>약재명</th>
                  <td>
                    <div class="table_list">
                      <div class="table_option">
                        <div class="form_select"></div>
                        <button class="btn btn_md btn_blue" v-b-modal.medicineSearch>추가</button>
                      </div>
                      <table class="list no_view">
                        <colgroup>
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                          <col width="100">
                        </colgroup>
                        <thead>
                          <tr>
                            <th>약재명</th>
                            <th>이명</th>
                            <th>설명</th>
                            <th>용량</th>
                            <th>삭제</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="medicineList.length == 0">
                                <td colspan="5"><span>입력된 약재가 없습니다.</span></td>
                            </tr>
                            <tr v-for="(item, index) in medicineList" :key="index">
                                <td><span>{{ item.med_hrb_nm }}</span></td>
                                <td><span>{{ item.med_alias }}</span></td>
                                <td><span>{{ item.med_prfm }}</span></td>
                                <td>
                                <input type="text" class="form_control xl_limit" v-model="item.med_use_qnty">
                                <span>g</span>
                                </td>
                                <td><button class="icon icon_del" @click="fn_medList_delete(index)"></button></td>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>                
              </tbody>
            </table>
            <div class="bottom_box">
              <button class="btn btn_md btn_outline" @click="fn_move_page">목록</button>
              <div class="btn_box">
                <!-- <button class="btn btn_md btn_gray">취소</button> -->
                <button class="btn btn_md btn_darkblue" @click="fn_reg">저장</button>
              </div>
            </div>
          </div>
        </section>
      </div>
      <SearchModal 
        :title="'약재 검색'" 
        :searchName="'약재명'"
        :oneBtn="true"
        :btnLeft="'적용'" 
        :btnRight="'닫기'"
        @callback="fn_callback"
      />
    </div>
</template>

<script>
  import axios from 'axios'
  import SearchModal from "@/modal/admin/medicineSearch.vue"
  import commonUtil from "@/mixin/commonUtil";

  export default {
    name: 'InsuranceDictionaryMngtReg',
    mixins: [commonUtil],
    components: {
      SearchModal
    },
    data() {
      return {
        selected: null,
        regData : {
                insuranceDictionaryCd : "",
                insuranceDictionaryNm : "",
                insuranceDictionaryChinessNm : "",
                insuranceDictionarySource : '',
                insuranceDictionaryNote1 : '',
                insuranceDictionaryNote2 : '',
                nhisCategory : '',
                nhisType : '',
                standardPrescibeCd : '',
                limitPrice : 0,
                useYn : 'Y',
                status : ''
        },
        medicineList : [],
        NHIScategoryList : [],
        NHISTypeList : []
      }
    },
    async created(){
      //공통코드 - 제조회사
      this.NHIScategoryList = await this.getCode('GC00000011'); 
      this.NHISTypeList = await this.getCode('GC00000012'); 
    },
    mounted(){
        this.regData.status = this.$store.getters['dictionary/getStatus'];
        
        if(this.regData.status == 'M'){
            this.fn_search() 
        }
    },
    methods : {
      fn_move_page(){
			  this.$store.dispatch('dictionary/setStatus', '');
			  this.$router.push("/admin/dictionary/insuranceDictionaryMngt");
		  },
      fn_callback (medObject){
        medObject.use_qy = 0;
        this.medicineList.push(medObject);            
		  },
      fn_reg(){

            if(this.regData.insuranceDictionaryNm == null || this.regData.insuranceDictionaryNm == ''){
                alert("방제명을 입력해주세요");
                return;
            }

            if(this.regData.insuranceDictionarySource == null || this.regData.insuranceDictionarySource == ''){
                alert("출전을 입력해주세요");
                return;
            }

                let param = new Object();
                param.dictionaryInfo = this.regData;
                param.medicineList = this.medicineList;

                console.log("@@@@ param : %o",param);

                axios.post("/api/admin/dictionary/regInsuranceDictionary", 
                    param
                ).then((res) => {
                console.log("@@@@ res : %o",res);

                alert("저장되었습니다");
                this.fn_move_page();
            })
            .catch((err) => console.log(err));

        
      },
      fn_search(){

        let param = new Object();
        param.insuranceDictionaryCd = this.$store.getters['dictionary/getDictionaryCd'];

        console.log("@@@@ param : %o",param);

        axios
            .post("/api/admin/dictionary/getInsuranceDictionaryDetail", param)
            .then((res) => {
                console.log("@@@@ dtl res : %o",res);
                
                let dictinaryInfo = res.data.dictionaryInfo;
                this.medicineList = res.data.dictionaryHerbList;

                this.regData.insuranceDictionaryCd = dictinaryInfo.insurance_dictionary_cd;
                this.regData.insuranceDictionaryNm = dictinaryInfo.insurance_dictionary_nm;
                this.regData.insuranceDictionaryChinessNm = dictinaryInfo.insurance_dictionary_chinese_nm;
                this.regData.insuranceDictionarySource = dictinaryInfo.insurance_dictionary_source;
                this.regData.insuranceDictionaryNote1 = dictinaryInfo.insurance_dictionary_note1;
                this.regData.insuranceDictionaryNote2 = dictinaryInfo.insurance_dictionary_note2;
                this.regData.standardPrescibeCd = dictinaryInfo.standard_prescribe_cd;
                this.regData.limitPrice = dictinaryInfo.limit_price;
                this.regData.useYn = dictinaryInfo.use_yn;
                this.regData.nhisCategory = dictinaryInfo.insurance_category;
                this.regData.nhisType = dictinaryInfo.insurance_type;
     
                
                console.log("@@@@ dtl this.regData : %o",this.regData);

            })
            .catch((err) => console.log(err));
            
      },
      fn_medList_delete(idx){
        this.medicineList.splice(idx, 1);
      }
    }
  }
</script>